import { render, staticRenderFns } from "./BusinessFrontPageTitlesAndImage.vue?vue&type=template&id=77022f28&scoped=true&"
import script from "./BusinessFrontPageTitlesAndImage.vue?vue&type=script&lang=ts&"
export * from "./BusinessFrontPageTitlesAndImage.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessFrontPageTitlesAndImage.vue?vue&type=style&index=0&id=77022f28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77022f28",
  null
  
)

export default component.exports